export default {
  common: {
    search: '搜索',
    fixHead: '固定表头',
    cancelFix: '取消固定',
    downloadData: '下载数据',
    copyData: '复制数据',
    download: '下载',
    copy: '复制',
    reset: '重置',
    find: '查询',
    noData: '暂无数据',
    selected: '已选择',
    today: "今日",
    yesterday: "昨日",
    yesterdayT: "昨日",
    '2DaysAgoT': "前日",
    chart: "图",
    table: "表",
    currentPeriod: "本期",
    monthPeriod: "环比",
    yearPeriod: "同比",
    minute: "分钟",
    minuteU: "分钟",
    time: "时间",
    timeU: "时间",
    day: "日",
    clear: "清空",
    selectDate: "选择日期",
    date: '日期',
    logout: '退出登录',
    nongameP: '非游戏产品',
    gameP: '游戏产品',
    value: '值',
    month: "月",
    monthTime: "月份",
    week: "周",
    weekTime: "周次",
    year: "年",
    yearTime: "年份",
  },
  ux: {
    uxtools: 'UX工具',
  },
  searchBar: {
    empty: '暂无相关条目'
  },
  pageHeader: {
    saveSetting: '记住日期和服务器',
    gameSpec: '游戏专项',
    demandFollow: '需求跟进',
    dataDevelop: '数据开发',
    qa: '质量保证',
    offline: '下线页面',
    pageConfig: '页面配置',
    checkAll: '全选',
    server: "服务器",
    serverPlaceholder: '请选择服务器, 默认全服',
    serverList: '服务器列表',
    area: '大区',
    crossServerList: '跨服合服服务器',
    mustFill: '此字段必填'
  },
  chartTrans: {
    xAxis: '横轴',
    yAxis: '纵轴',
    compare: '对比',
  },
  chart: {
    showAllLegend: '显示所有图例',
    hideAllLegend: '关闭所有图例',
  },
  dataTable: {
    totalInfo: '共 {0} 条记录 第 {1} 条',
    summary: "汇总"
  },
  fixed: {
    calculating: "计算中...",
    noData: '暂无数据',
    loading: "数据加载中...",
    all: "全部",
    android: "安卓",
    androidS: '安卓',
    setDate: '添加对比日期',
    setYear: '添加对比年份',
    realtime: {
      name: "实时概览",
      title: "实时概览",
      overview: {
        title: "数据概览",
        dataPay: "充值",
        dataNew: "新增",
        dataDau: "DAU"
      },
      online: {
        title: "在线趋势",
        time: "时间",
        cnt: "在线人数",
        deviceTitle: "在线设备趋势"
      },
      conversion: {
        title: "每日登录设备转化率",
        device: "台设备",
        retention: "留存",
        allChannel: "全部渠道",
        overall: "整体留存",
        stage: "阶段留存",
        inConversion: "登录转化"
      }
    },
    pay: {
      name: "付费结构",
      title: "付费结构",
      overview: {
        title: "充值数据概览",
        dataCash: "充值金额",
        dataPayAccCnt: "充值账号数",
        dataPayRatio: "充值率",
        dataArpu: "ARPU"
      },
      structure: {
        title: "付费结构",
        amount: "充值金额",
        login: "登录人数",
        rate: "占比",
        vipLevel: "vip等级",
        remark: "备注",
        totalRechargePercentage: "历史总充值占比",
        statisticalRechargePercentage: "统计期充值占比",
        contributions: "统计期充值贡献",
        loginPercentage: "登录人数占比",
        Unlogin: "7日未登录人数",
        total: "历史人数",
        wastage: "流失率"
      },
      ltv: {
        title: "当日新增账号LTV",
        newAccCount: "新增账号数",
        accCount: "账号数",
        ltv1: "账号1日累计(LTV-1)",
        ltv3: "账号3日累计(LTV-3)",
        ltv7: "账号7日累计(LTV-7)",
        ltv15: "账号15日累计(LTV-15)",
        ltv30: "账号30日累计(LTV-30)"
      }
    },
    report: {
      name: "运营报表",
      title: "运营报表",
      overview: {
        title: "数据概览",
        dataCash: "充值金额",
        dataPayAccount: "充值账号数",
        dataNew: "新增",
        daily: "日报",
        weekly: "周报",
        monthly: "月报",
        lastWeek: "上周",
        weekCount: "第{count}周"
      }
    },
    new: {
      name: "新增留存",
      title: "新增留存",
      min: "分钟",
      overview: {
        title: "新增数据概览",
        dataAccCnt: "新增账号",
        dataRoleCnt: "新增角色"
      },
      liucun: {
        title: "账号/角色留存",
        accTitle: "新增账号留存",
        roleTitle: "新增角色留存",
        dataAccCnt: "新增账号数",
        dataRoleCnt: "新增角色数"
      },
      week_liucun: {
        title: "周新增留存",
        week: "自然周",
        week_1: "当周留",
        week_2: "次周留",
        week_3: "3周留",
        week_4: "4周留",
        week_5: "5周留",
      },
      minuteReach: {
        title: "新增角色分钟到达率",
        ratio: "到达率",
        min: "分钟"
      },
      minuteReachTrend: {
        title: "新增角色分钟到达率趋势",
        ratio_5: "5分钟到达率",
        ratio_15: "15分钟到达率",
        ratio_30: "30分钟到达率",
        ratio_60: "60分钟到达率",
        ratio_90: "90分钟到达率",
        ratio_120: "120分钟到达率",
        ratio: "到达率"
      }
    },
    online: {
      name: "登录在线",
      title: "登录在线",
      cnt: "人数",
      overview: {
        title: "登录数据概览",
        dataAccCnt: "登录账号",
        dataDeviceCnt: "登录设备",
        dataRoleCnt: "登录角色"
      },
      online: {
        title: "在线趋势",
        time: "时间",
        cnt: "在线人数"
      },
      level: {
        title: "等级分布",
        level: "等级"
      },
      class: {
        title: "职业分布",
        class: "职业"
      },
      map: {
        title: "DAU地图分布",
        world: "世界地图",
        china: "中国地图",
        area: "地区",
        cnt: "人数",
        
      }
    },
    experience: {
      title: 'UX体验管理',
    },
    veteran: {
      title: '历史玩家挖掘',
    },
    fashion: {
      title: '时尚趋势',
    },
    test: {
      title: '测试专栏',
    },
    reflow: {
      title: '回流留存'
    },
    version: {
      title: '效果监测'
    },
    consume: {
      title: '消费专题'
    },
    subjects: {
      title: "游戏专项",
    },
  },
  day: {
    day_2: "次日",
    day_3: "第3日",
    day_4: "第4日",
    day_5: "第5日",
    day_6: "第6日",
    day_7: "第7日",
    day_8: "第8日",
    day_9: "第9日",
    day_10: "第10日",
    day_11: "第11日",
    day_12: "第12日",
    day_13: "第13日",
    day_14: "第14日",
    day_15: "第15日",
    day_30: "第30日"
  },
  week: {
    short_1: "一",
    short_2: "二",
    short_3: "三",
    short_4: "四",
    short_5: "五",
    short_6: "六",
    short_7: "日"
  },
  month: {
    long_1: "一月",
    long_2: "二月",
    long_3: "三月",
    long_4: "四月",
    long_5: "五月",
    long_6: "六月",
    long_7: "七月",
    long_8: "八月",
    long_9: "九月",
    long_10: "十月",
    long_11: "十一月",
    long_12: "十二月",
    long_other: "未知",
    short_1: "1月",
    short_2: "2月",
    short_3: "3月",
    short_4: "4月",
    short_5: "5月",
    short_6: "6月",
    short_7: "7月",
    short_8: "8月",
    short_9: "9月",
    short_10: "10月",
    short_11: "11月",
    short_12: "12月",
    short_other: "未知"
  },
};
